import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';
import { STRING } from '../../types';
@Component({
	selector: 'app-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent implements OnInit {
	@Input() formElement: any;
	@Input() formValue?: FormGroup;
	@Input() value: any = {};
	@Input() disabled = false;
	viewCol = 12;
	checkBoxClass: any = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.checkbox];
	labelClass: any;
	inputClass: any = [];
	@Input() label: string;
	@Input() required: boolean;
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	rowClass: any;
	@Output() valueChange = new EventEmitter();
	@Output()
	change = new EventEmitter<{
		name: string;
		value: string;
	}>();
	constructor() {}

	private _formatView() {
		this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
		const labelDiv = this.formElement.labelDiv;
		const inputDiv = this.formElement.inputDiv;
		let derivedLabelClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)
		];
		let derivedInputClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)
		];
		if (this.formElement.row) {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row
			];
			derivedLabelClass.push(
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row
			);
		} else {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.flexRow
			];
			derivedInputClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
			derivedLabelClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
		}
		this.inputClass = this.inputClass.concat(derivedInputClass);
		this.labelClass = this.labelClass.concat(derivedLabelClass);
		switch (this.formElement.colDivision) {
			case 1: {
				this.viewCol = 12;
				break;
			}
			case 2: {
				this.viewCol = 6;
				break;
			}
			case 3: {
				this.viewCol = 4;
				break;
			}
			case 4: {
				this.viewCol = 3;
				break;
			}
		}
		this.checkBoxClass.push(FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(this.viewCol));
	}
	// private _formatView1() {
	// 	this.labelClass = ['col-form-label field-label padding-top-zero'];
	// 	this.inputClass = ['input-padding'];
	// 	this.checkBoxClass = ['m-checkbox m-checkbox--default'];
	// 	let derivedLabelClass = [];
	// 	let derivedInputClass = [];
	// 	if (this.formElement.align && this.formElement.align === 6) {
	// 		derivedLabelClass.push('col-4');
	// 		derivedInputClass.push('col-8');
	// 	} else {
	// 		derivedLabelClass.push('col-2');
	// 		derivedInputClass.push('col-10');
	// 	}
	// 	const labelDiv = this.formElement.labelDiv;
	// 	const inputDiv = this.formElement.inputDiv;
	// 	derivedLabelClass = [`col-md-${labelDiv}`];
	// 	derivedInputClass = [`col-md-${inputDiv}`];
	// 	if (this.formElement.row) {
	// 		derivedLabelClass.push('right-text');
	// 		this.rowClass = ['row', 'flex-row'];
	// 	} else {
	// 		derivedLabelClass.push('col-md-12');
	// 		derivedInputClass.push('col-md-12');
	// 	}
	// 	this.labelClass = this.labelClass.concat(derivedLabelClass);
	// 	this.inputClass = this.inputClass.concat(derivedInputClass);
	// 	switch (this.formElement.colDivision) {
	// 		case 1: {
	// 			this.viewCol = 12;
	// 			break;
	// 		}
	// 		case 2: {
	// 			this.viewCol = 6;
	// 			break;
	// 		}
	// 		case 3: {
	// 			this.viewCol = 4;
	// 			break;
	// 		}
	// 		case 4: {
	// 			this.viewCol = 3;
	// 			break;
	// 		}
	// 	}
	// 	this.checkBoxClass.push(`col-${this.viewCol}`);
	// }
	ngOnInit() {
		let hasValue;
		if (this.formValue) {
			this.formValue.valueChanges.subscribe(val => {
				this.onFormValueChange(val);
			});
		}
		if (this.formElement) {
			this._formatView();
			this.disabled = this.formElement.disabled || false;
			if (this.formElement.value) {
				hasValue = true;
			}
			this.value = this.formElement.value || {};
		}
		this._assignDefaultValue();
		if (hasValue) {
			this.onChange();
		}
	}
	private _assignDefaultValue() {
		this.formElement.checkboxes.forEach(checkbox => {
			this.value[checkbox.name] = this.value[checkbox.name]
				? true
				: false;
		});
	}
	onFormValueChange(val) {
		val = val || {};
		if (!Helpers.compareObj(this.value, val)) {
			this.value = val;
			if (!this.value) {
				this.value = {};
				this.formElement.checkboxes.map(checkbox => {
					const checkboxName = checkbox.name;
					this.value[checkboxName] = false;
				});
			}
			this._assignDefaultValue();
			this.onChange();
			this.formValue.markAsPristine();
		}
		if (this.formElement.markAsUntouched) {
			this.formElement.markAsUntouched = false;
			this.formValue.markAsPristine();
			this.formValue.markAsUntouched();
		}
	}
	onChange() {
		this.makeDirty();
		this.inputValue = this.value;
		this.valueChange.emit(this.value);
		this.change.emit({
			name: this.formElement.name,
			value: this.value
		});
	}
	isDisabled() {
		return (this.disabled || this.formElement.readOnly) ? STRING.EMPTY : null;
	}

	set inputValue(value) {
		if (this.formValue) {
			this.formValue.setValue(this.value);
		}
	}
	makeDirty() {
		if (this.formValue) {
			this.formValue.markAsDirty();
			this.formValue.markAsTouched();
		}
	}
}
